import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=0b940bdb&scoped=true&"
var script = {}
import style0 from "./Header.vue?vue&type=style&index=0&id=0b940bdb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b940bdb",
  null
  
)

export default component.exports